import React from 'react';
import composerNameToID  from '../helpers/composerNameToID';

function HeaderComposer({composer}) {
  if (Array.isArray(composer.works) && composer.works.length > 0) {
    return <li>
      <a href={`#${composerNameToID(composer.name)}`}>{composer.name}</a>
      <span> ({composer.yearBorn} - {composer.yearDied}) [{composer.nationality}]</span>
    </li>;
  } else {
    return <li>
      <span href={`#${composerNameToID(composer.name)}`}>{composer.name}</span>
    </li>;
  }
}

function HeaderComposerList(props) {
  const composers = props.composers;

  const musicEraAndComposerList = composers.map((era) => {
    const composerList = era.composers.map((composer) => {
      return <HeaderComposer composer={composer} key={`header-composer-${composer.name}`}/>
    });

    return (
      <div key={`side-era-${era.era}`}>
        <h1 className="sideEra">{era.era}</h1>
        <ul>{composerList}</ul>
      </div>
    )
  });

  return (
    <div>
      {musicEraAndComposerList}
    </div>
  );
}

export default HeaderComposerList;
